import React from "react";
import { LuUser } from "react-icons/lu";
import { hasAssignedLogisticsTeamUser } from "../../utils/logisticsRfqManagerAssignment";

export function hasAssignedLogisticsUser(row) {
  const name = String(row?.assignedLogisticsUserName || "").trim();
  const id = row?.assignedLogisticsUserId ?? row?.assignedLogisticsUserAccessUserId;
  return Boolean(name) || (id != null && Number(id) > 0);
}

export function getCurrentAssigneeDisplay(row) {
  const explicitName = String(row?.currentAssigneeName || "").trim();
  const explicitRole = String(row?.currentAssigneeRole || row?.providerAssignmentOwnerRoleLabel || "").trim();

  if (explicitName) {
    return { name: explicitName, role: explicitRole || null };
  }

  const managerName = String(row?.assignedLogisticsManagerName || "").trim();
  const userName = String(row?.assignedLogisticsUserName || "").trim();
  const teamUser = hasAssignedLogisticsTeamUser(row);

  if (teamUser && userName) {
    return { name: userName, role: "Logistics User" };
  }
  if (managerName) {
    return { name: managerName, role: "Logistics Manager" };
  }
  if (userName) {
    return { name: userName, role: "Logistics Manager" };
  }
  return { name: "", role: null };
}

export default function LogisticsRfqAssignedUserBadge({ row }) {
  const { name, role } = getCurrentAssigneeDisplay(row);
  if (!name) {
    return <span className="brrq-admin-muted">—</span>;
  }

  const autoTag =
    role === "Logistics User" && row.logisticsUserAssignmentType === "automatic" ? (
      <span className="brrq-admin-user-badge__tag">Auto</span>
    ) : null;

  return (
    <span className="brrq-admin-user-badge">
      <span className="brrq-admin-user-badge__icon" aria-hidden>
        <LuUser />
      </span>
      <span className="brrq-admin-user-badge__text">
        {name}
        {role ? <span className="brrq-admin-user-badge__role"> ({role})</span> : null}
      </span>
      {autoTag}
    </span>
  );
}
